/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { LogSourceLocationCloudTrail } from '../models/LogSourceLocationCloudTrail';
import { LogSourceLocationCloudWatchLogs } from '../models/LogSourceLocationCloudWatchLogs';
import { LogSourceLocationDatadog } from '../models/LogSourceLocationDatadog';
import { LogSourceLocationSplunkDdss } from '../models/LogSourceLocationSplunkDdss';

/**
* Location details for the log source.
*/
export class LogSourceLocation {
  'cloudTrail'?: LogSourceLocationCloudTrail;
  'datadog'?: LogSourceLocationDatadog;
  'cloudWatchLogs'?: LogSourceLocationCloudWatchLogs;
  'splunkDdss'?: LogSourceLocationSplunkDdss;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "cloudTrail",
      "baseName": "cloudTrail",
      "type": "LogSourceLocationCloudTrail",
      "format": ""
    },
    {
      "name": "datadog",
      "baseName": "datadog",
      "type": "LogSourceLocationDatadog",
      "format": ""
    },
    {
      "name": "cloudWatchLogs",
      "baseName": "cloudWatchLogs",
      "type": "LogSourceLocationCloudWatchLogs",
      "format": ""
    },
    {
      "name": "splunkDdss",
      "baseName": "splunkDdss",
      "type": "LogSourceLocationSplunkDdss",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return LogSourceLocation.attributeTypeMap;
  }

  public constructor() {
  }
}

